<script setup>
import {onMounted, ref, watch} from "vue";
import needsService from "@/services/needs.service";
import {useRoute} from "vue2-helpers/vue-router";

const emit = defineEmits(['completed'])
const route = useRoute();

const step = ref(1);
const show = ref(false);
const alwaysShow = route.query.onboarding;

watch(step, value => {
    if (value > 3) {
        show.value = false;
        emit('completed');
    }

    if (!alwaysShow) {
        saveStep();
    }
});

onMounted(() => {
    if (alwaysShow) {
        show.value = true;
    } else {
        getLastStep();
    }
});

async function getLastStep() {
    const {data} = await needsService.getOnboardingStep();
    // step.value = data ?? 1;
    step.value = (data && data > 0) ? data : 1;

    if (step.value <= 3) {
        show.value = true;
    }
}

async function saveStep() {
    await needsService.saveOnboardingStep(step.value);
}
</script>

<template>
    <div id="needs-onboarding" v-if="show" class="needs-onboarding" :class="`needs-onboarding-${step}`">
        <div class="needs-onboarding__inner">
            <div v-if="step === 1">
                <h2 class="heading2">Welcome to SwitchPitch</h2>

                <ul class="needs-onboarding__list">
                    <li>Log Needs</li>
                    <li>Identify AI Solutions</li>
                    <li>Get Tailored Ecosystem Recommendations</li>
                </ul>
            </div>

            <div v-else-if="step === 2" class="pb-5">
                <h2 class="heading2">Startup Matching</h2>

                <p>Startups matching your needs are added to a queue for review</p>
                <p class="mb-5">Use the match score and our proprietary Partnership Readiness Score to determine fit</p>
            </div>

            <div v-else-if="step === 3" class="pb-5">
                <h2 class="heading2">Ecosystem Recommendations</h2>

                <p class="mb-5">Our VC, Accellerator and incubator partners view your anonymized need and recommend their proprietary startup portfolios</p>
            </div>

            <template>
                <!-- {{step}} -->
            </template>

            <div class="btn-xl-wrapper">
                <a v-if="step > 1" @click="step--" class="btn btn-xl btn-xl-back"></a>

                <a @click="step++" class="btn btn-xl btn-xl-next">
                    <template v-if="step === 3">
                        Get Started
                    </template>

                    <template v-else>
                        Next
                    </template>
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>
